module.exports = __webpack_public_path__ + "img/purple-square-table-12.c4b21752.png";